class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  lockMobileSearchViewport() {
    if (!this.classList.contains('header__search') || !window.matchMedia('(max-width: 749px)').matches) return;

    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    this.viewportMeta = viewport;
    this.originalViewportContent = viewport.getAttribute('content') || 'width=device-width,initial-scale=1';

    const viewportRules = this.originalViewportContent
      .split(',')
      .map((rule) => rule.trim())
      .filter((rule) => rule && !/^maximum-scale\s*=/i.test(rule));

    viewportRules.push('maximum-scale=1');
    viewport.setAttribute('content', viewportRules.join(','));
  }

  restoreMobileSearchViewport() {
    if (!this.viewportMeta || this.originalViewportContent == null) return;

    this.viewportMeta.setAttribute('content', this.originalViewportContent);
    this.viewportMeta = null;
    this.originalViewportContent = null;
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.lockMobileSearchViewport();
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.restoreMobileSearchViewport();
  }
}

customElements.define('details-modal', DetailsModal);
